/* eslint-disable global-require */
import { startApp } from "@quintype/framework/client/start";
import { renderApplication, preRenderApplication } from "./render";
import wretch from "wretch";

import CustomReducers from "../isomorphic/components/helper/reducers";

import "../../app/assets/stylesheets/app.scss";

function enableHotReload(store) {
  if (process.env.NODE_ENV === "development" && module.hot) {
    module.hot.accept("./render", () => renderApplication(store));
  }
}

window.addEventListener("load", () => {
  window.dataLayer.push({ originalLocation: window.location.href });
});

global.wretch = wretch;
global.width = window.innerWidth;

startApp(renderApplication, CustomReducers, {
  enableServiceWorker: process.env.NODE_ENV === "production",
  appVersion: require("../isomorphic/app-version"),
  preRenderApplication,
}).then(enableHotReload);
